import React from 'react';

import { IconProps } from './types';

const Pause: React.FC<IconProps> = () => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.38824 7.33366C5.24009 7.33366 5.11046 7.2781 4.99935 7.16699C4.88824 7.05588 4.83268 6.92625 4.83268 6.7781V1.22255C4.83268 1.0744 4.88824 0.94477 4.99935 0.833659C5.11046 0.722548 5.24009 0.666992 5.38824 0.666992H6.77713C6.92527 0.666992 7.0549 0.722548 7.16602 0.833659C7.27713 0.94477 7.33268 1.0744 7.33268 1.22255V6.7781C7.33268 6.92625 7.27713 7.05588 7.16602 7.16699C7.0549 7.2781 6.92527 7.33366 6.77713 7.33366H5.38824ZM1.22157 7.33366C1.07342 7.33366 0.943794 7.2781 0.832682 7.16699C0.721571 7.05588 0.666016 6.92625 0.666016 6.7781V1.22255C0.666016 1.0744 0.721571 0.94477 0.832682 0.833659C0.943794 0.722548 1.07342 0.666992 1.22157 0.666992H2.61046C2.75861 0.666992 2.88824 0.722548 2.99935 0.833659C3.11046 0.94477 3.16602 1.0744 3.16602 1.22255V6.7781C3.16602 6.92625 3.11046 7.05588 2.99935 7.16699C2.88824 7.2781 2.75861 7.33366 2.61046 7.33366H1.22157Z"
        fill="white"
      />
    </svg>
  );
};

export default Pause;
